import { dictionaryApi } from './dictionaryClient';

export type Language = {
  id: number;
  name: string;
  code: string;
};

function normalizeList(data: unknown): Language[] {
  if (Array.isArray(data)) return data as Language[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: Language[] }).data;
  }
  return [];
}

export async function listLanguages(): Promise<Language[]> {
  const res = await dictionaryApi.get<unknown>('/language');
  return normalizeList(res.data);
}

export async function getLanguage(id: number): Promise<Language> {
  const res = await dictionaryApi.get<Language>(`/language/${id}`);
  return res.data;
}

export async function createLanguage(body: { name: string; code: string }): Promise<Language> {
  const res = await dictionaryApi.post<Language>('/language', body);
  return res.data;
}

export async function updateLanguage(
  id: number,
  body: Partial<Pick<Language, 'name' | 'code'>>
): Promise<Language> {
  const res = await dictionaryApi.patch<Language>(`/language/${id}`, body);
  return res.data;
}

export async function deleteLanguage(id: number): Promise<void> {
  await dictionaryApi.delete(`/language/${id}`);
}
